import { render } from "./KbHint.vue?vue&type=template&id=5cc3adf4&scoped=true"
import script from "./KbHint.vue?vue&type=script&lang=js"
export * from "./KbHint.vue?vue&type=script&lang=js"

import "./KbHint.vue?vue&type=style&index=0&id=5cc3adf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc3adf4"]])

export default __exports__